export default "__VITE_ASSET__18d882e1__"